var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUpIcon = function SvgArrowUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0411 22.0001H13.0411L13.0411 5.51471L18.5924 11.3474L20.0411 9.9686L12.7527 2.31058C12.3588 1.89679 11.699 1.89642 11.3047 2.30978L4 9.9678L5.4472 11.3482L11.0411 5.4837L11.0411 22.0001Z",
    fill: "#767676"
  })));
};
export { SvgArrowUpIcon as ReactComponent };
export default __webpack_public_path__ + "assets/009adf90.svg";